// extracted by mini-css-extract-plugin
var _1 = "AddWidget-module_add_widget__TMNgqy";
var _2 = "AddWidget-module_add_widget_button__ijUs7n";
var _3 = "AddWidget-module_add_widget_label__iCmdQe";
export { _1 as "add_widget", _2 as "add_widget_button", _3 as "add_widget_label" }
